import { useState } from "react";
import { t } from "i18next";
import { useMediaExport } from "../../hooks/useMediaExport";
import { IconButton } from "@material-tailwind/react";
import { Progress } from "@material-tailwind/react";

type MediaItem = EasyTech.Photo | EasyTech.WorkorderPhoto | EasyTech.WorkorderSignature;

interface ExportMediaButtonProps {
  workorder: EasyTech.Workorder;
  className?: string;
  children: React.ReactNode;
  photos: MediaItem[];
  signatures: MediaItem[];
  getPhotoDownloadUrl: (photoId: string) => string;
  getSignatureDownloadUrl: (signatureId: string) => string;
}

export const ExportMediaButton: React.FC<ExportMediaButtonProps> = ({
  workorder,
  className,
  children,
  photos,
  signatures,
  getPhotoDownloadUrl,
  getSignatureDownloadUrl
}) => {
  const [showProgress, setShowProgress] = useState(false);
  
  const {
    exportMediaAsZip,
    exporting,
    progress,
    error
  } = useMediaExport({
    workorderId: workorder.id,
    photos,
    signatures,
    getPhotoDownloadUrl,
    getSignatureDownloadUrl
  });

  const handleExport = async () => {
    setShowProgress(true);
    await exportMediaAsZip();
    setTimeout(() => {
      setShowProgress(false);
    }, 3000); // Cache la barre de progression après 3 secondes
  };

  return (
    <div className={`export-media-button-container ${className}`}>
      <div 
        onClick={!exporting ? handleExport : undefined} 
        className={`${exporting ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
      >
        <IconButton 
          className="icon-button bg-white"
          disabled={exporting}
        >
          {children}
        </IconButton>
      </div>
      
      {showProgress && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl w-96">
            <h2 className="text-xl font-bold mb-4">
              {exporting ? t("Exporting media...") : t("Export completed")}
            </h2>
            <Progress value={progress} color="blue" className="mb-4" />
            <p className="text-center">{progress}%</p>
            {error && <p className="text-red-500 mt-2">{error}</p>}
            {!exporting && (
              <button 
                className="mt-4 w-full px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                onClick={() => setShowProgress(false)}
              >
                {t("Close")}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}; 